import { memo } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { formattedValue } from "../../Services/common";
import { getPaymentColor } from "../../Utils/appUtils";
import { changeDateFormatForDisplay } from "../../Utils/dateUtils";
import { slice } from "../../Utils/stringUtils";
import IconResource from "../../Wrapper/IconResource/IconResource";
import AnimatedPage from "../AnimatedPage/AnimatedPage";
import DateRangePicker from "../_widgets/DateRangePicker/DateRangePicker";
import Input from "../_widgets/Input/Input";
import MainLoader from "../_widgets/Loader/MainLoader";
import MultiSelectDropdown from "../_widgets/MultiSelect/MultiSelectDropdown";
import NavBar from "../_widgets/NavBar/NavBar";
import CustomPagination from "../_widgets/Pagination/Pagination";
import Text from "../_widgets/Text/Text";
import CustomTooltip from "../_widgets/Tooltip/CustomTooltip";
import ImageResource from "../../Wrapper/ImageResource/ImageResource";
const MedicineBillUi = memo(
  ({
    searchQuery,
    setSearchQuery,
    dates,
    setDates,
    datePickerEndRef,
    datePickerStartRef,
    loading,
    onPageChange,
    getMedicineBillList,
    medicineBillList,
    selectedOptions,
    handleDropdownChange,
    clearFilter,
    statusOptions,
    openDetailsPage,
  }) => {
    return (
      <AnimatedPage>
        <NavBar
          heading="Medicine Bill"
          onClick={() => {
            document.body.classList.toggle("side_active");
            document.body.classList.toggle("side_active_mb");
          }}
          Icon="menu"
        />
        <div className="patient_list white_card">
          <div className="top_bar">
            <Text type="h2" text={""} />
            {/* <div className="d-flex align-items-start align-items-md-center gap-3"> */}
            <Row className="search_filter">
              <Col lg={2} xs={4} md={2}>
                <div className="bg_grey d-flex align-items-end justify-content-end position-relative px-2 py-1">
                  {selectedOptions.length > 0 ? (
                    <div className="round-notification">{selectedOptions.length}</div>
                  ) : (
                    ""
                  )}

                  <MultiSelectDropdown
                    items={statusOptions}
                    name={
                      <div className="d-flex align-items-center gap-1">
                        <IconResource type={"filter"} size={12} color={"var(--primary)"} />
                        <small
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "var(--primary)",
                            cursor: "pointer",
                          }}
                          className=""
                        >
                          Status
                        </small>
                        {selectedOptions.length > 0 ? (
                          <IconResource type={"cross"} size={12} onClick={clearFilter} />
                        ) : (
                          ""
                        )}
                      </div>
                    }
                    selectedOptions={selectedOptions}
                    onChange={handleDropdownChange}
                  />
                </div>
              </Col>

              <Col lg={3} xs={8} md={3}>
                <div>
                  <Input
                    placeholder="Search"
                    id="searchInput"
                    suffixIcon="search"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onClickIconSuff={() => getMedicineBillList()}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        getMedicineBillList();
                      }
                    }}
                    iconTooltip="Search"
                  />
                </div>
              </Col>
              <Col lg={7} xs={12} md={7} className="px-md-1">
                <div className="date_range_picker">
                  <DateRangePicker
                    startDate={dates?.startDate}
                    setStartDate={(startDate) => setDates({ ...dates, startDate })}
                    endDate={dates?.endDate}
                    setEndDate={(endDate) => setDates({ ...dates, endDate })}
                    onChange={(startDate, endDate) => setDates({ startDate, endDate })}
                    datePickerStartRef={datePickerStartRef}
                    datePickerEndRef={datePickerEndRef}
                    showDateShortcuts={true}
                  />
                </div>
              </Col>
            </Row>
            {/* </div> */}
          </div>

          <div className="custom_table position-relative">
            {loading ? (
              <MainLoader />
            ) : medicineBillList?.data?.length > 0 ? (
              <>
                <div>
                  <Table responsive hover>
                    <thead>
                      <tr>
                        <th>Bill No.</th>
                        <th>Bill Date</th>
                        <th style={{ width: "25%" }}>Medicine</th>
                        <th>Supplier</th>
                        <th>Bill Amount</th>
                        <th>Status</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>

                    <tbody>
                      {medicineBillList?.data?.map((data, index) => (
                        <tr
                          key={data.id}
                          onClick={() => openDetailsPage(data?.bill_no)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{data.bill_no || "-"}</td>
                          <td>
                            <CustomTooltip text={data.bill_dates} placement="top">
                              {slice(
                                data.bill_dates
                                  .split(",")
                                  .map((date) => changeDateFormatForDisplay(date.trim()))
                                  .join(", "),
                                25,
                              ) || "-"}
                            </CustomTooltip>
                          </td>

                          <td className="word-break">
                            <CustomTooltip text={data.product_names} placement="top">
                              {data.product_names || "-"}
                            </CustomTooltip>
                          </td>
                          <td>
                            <CustomTooltip text={data.supplier_names} placement="top">
                              {slice(data.supplier_names, 20) || "-"}
                            </CustomTooltip>
                          </td>
                          <td>{formattedValue(data.total_net_amount_rupee, true, true)}</td>
                          <td>
                            <div className="d-flex flex-wraps">
                              {data.statuses?.split(",").map((status, idx) => (
                                <div
                                  key={idx}
                                  className={`status mx-1 status__${getPaymentColor(status.trim())}`}
                                >
                                  <Text text={status.trim()} />
                                </div>
                              ))}
                            </div>
                          </td>
                          <td>
                            <CustomTooltip text={data.remarks} placement="top">
                              {slice(data.remarks, 20) || "-"}
                            </CustomTooltip>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                <CustomPagination
                  activePage={medicineBillList?.current_page}
                  onPageChange={onPageChange}
                  pageLength={medicineBillList?.per_page}
                  totalData={medicineBillList?.total}
                  lastPage={medicineBillList?.last_page}
                />
              </>
            ) : (
              <>
                <div className="no_data position-relative">
                  <ImageResource type="noData" style={{ width: "300px" }} className="img-fluid" />
                  <Text type="h2" text="There is no data to display. Try re-setting filters!" />
                </div>
              </>
            )}
          </div>
        </div>
      </AnimatedPage>
    );
  },
);
export default MedicineBillUi;
